import { WizardCigarettePreview } from './WizardCigarettePreview';

export default WizardCigarettePreview;
